import { Grid } from '@yes.technology/react-toolkit'
import styled from 'styled-components'

export const StyledContainer = styled(Grid)`
  max-width: 1920px;
`
